// This is a mapping of "this function is USED by these functions"
// e.g. "getApplication": [USED BY THESE FUNCTIONS]
// so when getApplication is revalidated, we then
// call the array of functions to revalidate those

export const cacheDependencyMap: Record<string, string[]> = {
	// Primary / entry-point events
	language: ["getTranslations"],
	translations: ["getTranslations"],
	application: ["getApplication"],
	theme: ["getTheme", "getShareClassTheme"],
	shareClass: ["getShareClassProfile", "getShareClassPrice", "getShareClassAssetAllocation"],
	// Secondary / cascaded events
	getApplication: ["getShareClassCompare", "getShareClasses", "getShareClassDashboard"],
	getShareClassTheme: [
		"getShareClassCompare",
		"getShareClassInsightsFromApi",
		"getDocumentCategories",
		"getPriceGroups",
		"getShareClassDashboard"
	],
	getShareClassProfile: ["getShareClassProfileByExternalId", "getShareClassCompare", "getPriceGroups", "getShareClassDashboard"],
	getTranslations: [
		"getArticles",
		"getDocumentCategories",
		"getDocuments",
		"getFundShareClasses",
		"getShareClassCompare",
		"getShareClassProfileByExternalId",
		"getShareClasses",
		"getPriceGroups",
		"getShareClassDashboard"
	],
	getTheme: [
		"getShareClassList",
		"getShareClassProfileByExternalId",
		"getShareClasses",
		"getFundShareClasses",
		"getArticles",
		"getDocuments"
	],
	getShareClassPrice: ["getPriceGroups"],
	getPriceGroupsFromData: ["getPriceGroups"],
	getShareClassDashboardWithOptions: ["getShareClassDashboard", "getShareClassCompare"],
	getShareClassList: ["getShareClasses"],
	getShareClassDashboard: ["fundDetailPageEntryPointData"],
	getShareClassListColumns: ["getShareClasses"]
};

export const cacheDependencySanityOverride: string[] = [];

export const invalidatedBy = (name: string) => {
	return Object.entries(cacheDependencyMap)
		.filter(([, dependencies]) => {
			return dependencies.includes(name);
		})
		.map(([parent]) => {
			return parent;
		});
};

export const getAllEvents = () => {
	const keys = Object.keys(cacheDependencyMap);
	const values = Object.values(cacheDependencyMap).flat();

	return Array.from(new Set([...keys, ...values]));
};
